import type { Pagination } from "./datatable";

interface TableHeaderProps {
	readonly pagination?: Pagination;
	readonly setPagination?: Setter<Pagination>;

	readonly globalSearch?: string;
	readonly setGlobalSearch?: Setter<string>;
}
export function TableHeader(props: TableHeaderProps) {
	return (
		<div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
			{props.pagination == null ? <div /> : (
				<label>
					<span>Mostrar</span>
					<select style={{ margin: "0 5px" }} value={props.pagination.pageSize} onChange={event => { props.setPagination?.(old => ({ ...old, pageSize: Number(event.target.value) })); }}>
						<option value="10">10</option>
						<option value="25">25</option>
						<option value="50">50</option>
						<option value="100">100</option>
					</select>
					<span>artículos</span>
				</label>
			)}


			{props.globalSearch == null ? <div /> : (
				<label>
					<span>Buscar: </span>
					<input
						type="search"
						style={{ margin: "0 5px", border: "1px solid #ccc", borderRadius: "4px" }}
						value={props.globalSearch}
						onChange={event => { props.setGlobalSearch?.(event.target.value); }}
					/>
				</label>
			)}
		</div>
	);
}
